import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { auth, sendPasswordResetEmail } from './firebase';
import './ForgotPassword.css';

const ForgotPassword = () => {
  const [email, setEmail] = useState('');
  const [error, setError] = useState('');
  const [success, setSuccess] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setSuccess(false);

    if (!email.trim()) {
      setError('Please enter your email address');
      return;
    }

    setIsLoading(true);

    try {
      await sendPasswordResetEmail(auth, email.trim());
      setSuccess(true);
    } catch (err) {
      console.error('ForgotPassword: Password reset error:', err);

      if (err.code === 'auth/user-not-found') {
        setError(
          'No password account found for this email. If you signed up with Google, use Login with Google on the sign-in page.'
        );
      } else if (err.code === 'auth/invalid-email') {
        setError('Please enter a valid email address.');
      } else if (err.code === 'auth/too-many-requests') {
        setError('Too many reset requests. Please try again later.');
      } else {
        setError('Failed to send password reset email. Please try again.');
      }
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="brand-forgot-password-container">
      <div className="brand-logo">
        <img src="/ugc3-logo.png" alt="UGC3 Logo" className="logo" />
      </div>

      <div className="brand-forgot-password-form">
        <h2>Reset your password</h2>
        <p>Enter your brand account email and we&apos;ll send you a link to reset your password.</p>

        {error && <div className="error-message">{error}</div>}

        {success ? (
          <div className="brand-forgot-password-success">
            <p>
              If an account exists for this email, we&apos;ve sent reset instructions. Check your inbox
              and spam folder.
            </p>
            <p className="brand-forgot-password-success-help">
              Signed up with Google? Use <strong>Login with Google</strong> on the sign-in page instead.
            </p>
          </div>
        ) : (
          <form onSubmit={handleSubmit}>
            <label htmlFor="email">Email *</label>
            <input
              type="email"
              id="email"
              placeholder="your@email.com"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              disabled={isLoading}
              autoComplete="email"
            />

            <button type="submit" className="cta-btn" disabled={isLoading}>
              {isLoading ? 'Sending...' : 'Send reset link'}
            </button>
          </form>
        )}

        <div className="brand-forgot-password-actions">
          <button
            type="button"
            className="brand-forgot-password-back"
            onClick={() => navigate('/signin')}
            disabled={isLoading}
          >
            Back to sign in
          </button>
        </div>
      </div>
    </div>
  );
};

export default ForgotPassword;
